import { ReactNode } from 'react';

import Navbar from 'components/navbar';
import Footer from 'components/footer/Footer';

export const BaseLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div
      style={{
        overflowX: 'hidden',
      }}
    >
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};
